import React from "react";
import Subscription_Plans from "./Subscription_Plans";
import FreshMealPlansHeading from "./FreshMealPlansHeading";

const features = [
  { icon: "/img/discount.svg", title: "Save up to 50%", desc: "on every subscription" },
  { icon: "/img/custom.svg", title: "Custom plans", desc: "tailored for you" },
  { icon: "/img/Reschedule.svg", title: "Change or reschedule", desc: "anytime you want" },
  { icon: "/img/local_shipping.svg", title: "Healthy meals", desc: "delivered every day" },
];

const Freshmealplans = ({ headingTag }) => {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="story-hero-head mb-3 text-base font-bold uppercase tracking-wide text-gray-900 md:text-lg">
          Meal Subscriptions
        </p>
        <FreshMealPlansHeading headingTag={headingTag} />
        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-gray-700 md:text-base">
          Healthy, balanced meal boxes delivered fresh every day. Because you
          can't exercise your way out of a bad diet.
        </p>
      </div>

      {/* Features */}
      <ul className="mx-auto mt-10 grid max-w-5xl grid-cols-2 gap-3 sm:gap-4 md:mt-12 md:grid-cols-4">
        {features.map(({ icon, title, desc }) => (
          <li
            key={title}
            className="flex flex-col items-center gap-3 rounded-2xl border border-[#1f5c33]/10 bg-white px-3 py-5 text-center shadow-sm sm:flex-row sm:px-4 sm:text-left"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#eef5ef]">
              <img src={icon} alt="" className="h-7 w-7" />
            </span>
            <span>
              <span className="block text-sm font-semibold leading-tight text-[#1f5c33]">
                {title}
              </span>
              <span className="mt-0.5 block text-xs text-gray-600">{desc}</span>
            </span>
          </li>
        ))}
      </ul>

      {/* Plans */}
      <Subscription_Plans />
    </section>
  );
};

export default Freshmealplans;
